export default "__VITE_ASSET__DC6TOyhf__"